import type { TruckSpec, ItemDimensions, ItemPosition, LoadingType } from "./types";
import { floorSlotsFor, layerHeightIn } from "./calculate-fit";

const SCENE_SCALE = 0.01;

export function computeItemPositions(
  truck: TruckSpec,
  item: ItemDimensions,
  perFloor: number,
  stackLayers: number,
  loadingType: LoadingType = "straight",
): Array<ItemPosition> {
  if (perFloor <= 0 || stackLayers <= 0) return [];
  if (item.lengthIn <= 0 || item.widthIn <= 0 || item.heightIn <= 0) {
    return [];
  }

  const slots = floorSlotsFor(truck, item, loadingType).slice(0, perFloor);
  const palletOffsetIn = item.palletized ? item.palletHeightIn : 0;
  const positions: Array<ItemPosition> = [];

  for (let layer = 0; layer < stackLayers; layer++) {
    const centerHeightIn =
      layer * layerHeightIn(item) + palletOffsetIn + item.heightIn / 2;
    for (const slot of slots) {
      positions.push({
        x: slot.alongIn * SCENE_SCALE,
        y: centerHeightIn * SCENE_SCALE,
        z: slot.acrossIn * SCENE_SCALE,
        rotationY: slot.turned ? Math.PI / 2 : 0,
      });
    }
  }

  return positions;
}
